import {
  DemoteMemberDocument,
  DemoteMemberMutation,
  DemoteMemberMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useDemoteMember = () => {
  const [mutation, { loading }] = useMutation(DemoteMemberDocument, {
    extractorFn: (data: DemoteMemberMutation) => data.teamsMutations.updateTeamsMembership,
  })

  const demoteMember = (variables: DemoteMemberMutationVariables) => {
    return mutation({
      variables,
      update(cache, { data }) {
        const demotedMembershipId = data?.teamsMutations.updateTeamsMembership.membership?.id

        if (!demotedMembershipId) return

        cache.modify({
          id: cache.identify({ __typename: 'TeamsMembership', id: demotedMembershipId }),
          fields: {
            lead() {
              return false
            },
          },
        })
      },
    })
  }

  return { loading, demoteMember }
}

export default useDemoteMember
